import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ThemeModeToggle from '@shared/components/ThemeModeToggle';
import ConnectivityDot from '@shared/components/ConnectivityDot';
import NotificationBell from '@features/notifications/components/NotificationBell';
import BasketIcon from '@features/basket/components/BasketIcon';
import { PortsToggle, AvcsToggle } from '@map/components/MapToolbar';

export default function TopBar() {
  return (
    <AppBar
      position="static"
      color="default"
      elevation={0}
      sx={{ borderBottom: 1, borderColor: 'divider', zIndex: 'appBar' }}
      data-testid="topbar"
    >
      <Toolbar variant="dense" sx={{ minHeight: 48, gap: 1 }}>
        {/* Left: Logo + App name */}
        <Typography variant="subtitle1" fontWeight={700} noWrap sx={{ mr: 2 }}>
          BV Terminal
        </Typography>

        <Box sx={{ flex: 1 }} />

        {/* Map controls */}
        <PortsToggle />
        <AvcsToggle />

        {/* Right: Theme toggle, Connectivity dot, Notifications, Basket */}
        <ThemeModeToggle />
        <ConnectivityDot />
        <NotificationBell />
        <BasketIcon />
      </Toolbar>
    </AppBar>
  );
}
